import { __decorate } from "tslib";
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import ObserverTextField from '../text-field/TextField';
import TextArea from '../text-area/TextArea';
import { IntlType } from './enum';
import Form from '../form/Form';
import localeContext from '../locale-context';
let IntlList = class IntlList extends Component {
    renderOptions() {
        const { name, lang, maxLengths, type, rows, cols, resize, getConfig } = this.props;
        const { supports } = localeContext;
        const tlsKey = getConfig('tlsKey');
        const FieldTag = type === IntlType.multipleLine ? TextArea : ObserverTextField;
        const otherProps = type === IntlType.multipleLine ? { rows, cols, resize } : {};
        return Object.keys(supports).map(key => {
            const maxLengthProps = maxLengths && maxLengths[key] ? { maxLength: maxLengths[key] } : {};
            return (React.createElement(FieldTag, Object.assign({}, maxLengthProps, { name: name ? `${tlsKey}.${name}.${key}` : key, autoFocus: key === lang, key: key }, otherProps)));
        });
    }
    render() {
        const { record, disabled, readOnly } = this.props;
        return React.createElement(Form, { disabled: disabled, readOnly: readOnly, record: record }, this.renderOptions());
    }
};
IntlList = __decorate([
    observer
], IntlList);
export default IntlList;
